exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.sync-status[data-v-6978c0ec] {\n    border-left: 4px solid #28a745;\n}\n.status-item[data-v-6978c0ec] {\n    display: flex;\n    align-items: center;\n}\n.modal.show[data-v-6978c0ec] {\n    background-color: rgba(0, 0, 0, 0.5);\n}\n.sync-logs .list-group-item[data-v-6978c0ec] {\n    border-left: 3px solid transparent;\n}\n.sync-logs .list-group-item[data-v-6978c0ec]:has(.text-success) {\n    border-left-color: #28a745;\n}\n.sync-logs .list-group-item[data-v-6978c0ec]:has(.text-danger) {\n    border-left-color: #dc3545;\n}\n", ""]);

// exports
